export enum ESUMSUBTypes {
    GET_SUMSUB_DATA = '[sumsub] get sumsub data',
    GET_SUMSUB_DATA_SUCCESS = '[sumsub] get sumsub data success',
    GET_SUMSUB_DATA_FAILED = '[sumsub] get sumsub data failed',
    REQUEST_APPROVED = '[sumsub] request approved',
}
